import classNames from "classnames";
import React from "react";
import { phaseIconMap } from "./utils";

interface Props {
  phase: server.dto.AppointmentPhases
  onToggled: (phase: server.dto.AppointmentPhases) => void
  isToggled: boolean
}

const PhaseFilter = (props: Props) => {
  const className = classNames(phaseIconMap[props.phase], {
    s1_transparent: !props.isToggled
  });

  return <div style={{ marginLeft: 5, display: "inline-block" }}>
    <a className={className} onClick={() => { props.onToggled(props.phase); }}></a>
  </div>;
};

export default PhaseFilter;